/*
 * Copyright (c) 2026. World Wide Generation Ltd
 */

import type { InitiativePlain } from '@g17eco/types/initiative';

export const buildAncestryPath = (initiativeId: string, treeMap: Map<string, InitiativePlain>): string[] => {
  const path: string[] = [];
  let current = treeMap.get(initiativeId);
  while (current) {
    path.unshift(current.name);
    if (!current.parentId) {
      break;
    }
    current = treeMap.get(current.parentId);
  }
  return path;
};

interface InitiativeBreadcrumbsProps {
  path: string[];
}

export const InitiativeBreadcrumbs = ({ path }: InitiativeBreadcrumbsProps) => {
  if (path.length <= 1) {
    return null;
  }
  const parentPath = path.slice(0, -1);
  return (
    <div className='small text-ThemeTextLight text-truncate'>
      {parentPath.join(' > ')}
    </div>
  );
};
